import { useCallback } from 'react';
import { flushSync } from 'react-dom';

import { useChecklistValidationSwitch } from '../../checklist/useChecklistValidationSwitch';
import type { ErrorRowProps } from './generic-error-row';
import { GenericErrorRow } from './generic-error-row';

export const ChecklistErrorRow = ({
  redirectHandler: initialRedirectHandler,
  ...props
}: ErrorRowProps) => {
  const [, setIsValidationOn] = useChecklistValidationSwitch(props.error?.fieldId ?? '');

  const redirectHandler = useCallback(
    (...args: Parameters<ErrorRowProps['redirectHandler']>) => {
      flushSync(() => {
        setIsValidationOn(true);
      });

      initialRedirectHandler(...args);
    },
    [initialRedirectHandler, setIsValidationOn],
  );

  return <GenericErrorRow {...props} redirectHandler={redirectHandler} />;
};
